import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockKeyhole, LogIn } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api
      .get("/auth/me")
      .then(({ data }) => {
        if (data.is_admin) navigate("/admin");
        else setChecking(false);
      })
      .catch(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A0F1C]">
        <div className="h-10 w-10 rounded-full border-2 border-white/20 border-t-blue-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0A0F1C] px-6">
      <div className="pointer-events-none absolute -top-40 -right-32 h-[520px] w-[520px] rounded-full bg-blue-600/20 blur-[150px]" />
      <div className="relative z-10 w-full max-w-md rounded-3xl border border-white/10 bg-[#0F1629] p-8 text-center shadow-2xl shadow-black/50">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-violet-500">
          <LockKeyhole className="h-7 w-7 text-white" />
        </div>
        <h1 className="mt-6 font-display text-2xl font-bold tracking-tight text-white">
          DecisionOS Admin
        </h1>
        <p className="mt-2 text-sm text-slate-400">
          Sign in with your authorised Google account to view survey analytics.
        </p>
        <button
          data-testid="google-login-btn"
          onClick={login}
          className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0A0F1C] transition-transform hover:-translate-y-0.5"
        >
          <LogIn className="h-4 w-4" />
          Continue with Google
        </button>
        <p className="mt-6 text-xs text-slate-500">
          Only allowlisted admin emails can access the dashboard.
        </p>
      </div>
    </div>
  );
}
